import moment from 'moment-timezone';
import { matchPath } from 'react-router-dom';

import { getToken, setToken } from '~/src/dash/api/auth/auth';
import { encodeQuery } from '~/src/dash/api/resource';
import { ISessionState } from '~/src/dash/reducers/session-reducers';
import { IUserState } from '~/src/dash/reducers/user-reducers';
import { getApiDomain } from '~/src/dash/resellers/utils/importResellerConfig';
import { formatDateSmall } from '~/src/dash/utils/date';
import { parseSearch } from '~/src/dash/utils/location';
import { encodeParams } from '~/src/dash/utils/params';

export interface IInventoryRoute {
  path: string;
  title: string;
}

export const RouteSession = {
  path: '/app/pub',
  title: 'Dashboard',
};

export const RouteReportNew = {
  path: '/app/pub/:pub/reports/new',
  title: 'Reporting',
};

export const RouteReportsList = {
  path: '/app/pub/:pub/reports',
  title: 'Reporting',
};

export const RouteReportExisting = {
  path: '/app/pub/:pub/reports/:report',
  title: 'Report Management',
};

export const RouteBidderReportsList = {
  path: '/app/pub/:pub/bidder-reports',
  title: 'Reporting',
};

export const RouteSSPReportList = {
  path: '/app/pub/:pub/ssp-reports',
  title: 'SSP Analytics',
};

export const RouteSSPReportNew = {
  path: '/app/pub/:pub/ssp-reports/new',
  title: 'SSP Analytics',
};

export const RouteSSPReportExisting = {
  path: '/app/pub/:pub/ssp-reports/report/:report',
  title: 'SSP Analytics',
};

export const RouteIABCategoryManager = {
  path: '/app/pub/:pub/iab-category',
  title: 'IAB Category Manager',
};

// Bidder
export const RouteBidderSettingsList = {
  path: '/app/pub/:pub/bidder-settings',
  title: 'Bidder Management',
};

export const RouteBidderBulkUpload = {
  path: '/app/pub/:pub/bidder-settings/upload',
  title: 'Bulk Upload Bidders',
};

export const RouteBidderSettingsNew = {
  path: '/app/pub/:pub/bidder-settings/bidder/new',
  title: 'Bidder Management',
};

export const RouteBidderSettingsExisting = {
  path: '/app/pub/:pub/bidder-settings/bidder/:bidder',
  title: 'Bidder Settings',
};

export const RouteBidderSettingsClone = {
  path: '/app/pub/:pub/clone-bidder/bidder/:bidder',
  title: 'Review Cloned Bidder',
};

export const RouteBidderBulkUpdate = {
  path: '/app/pub/:pub/bulk-update-bidders',
  title: 'Bulk Update Bidders',
};

// Channel
export const RouteChannelsView = {
  path: '/app/pub/:pub/channel',
  title: 'Channels',
};

export const RouteChannelNew = {
  path: '/app/pub/:pub/channel/new',
  title: 'Channels',
};

export const RouteChannelExisting = {
  path: '/app/pub/:pub/channel/:channel',
  title: 'Channels',
};

export const RouteChannelBulkUpdate = {
  path: '/app/pub/:pub/bulk-update-channels',
  title: 'Bulk Update Channels',
};

export const RouteChannelGroupBulkUpdate = {
  path: '/app/pub/:pub/channel-groups/bulk-update-channel-groups',
  title: 'Bulk Update Channel Groups',
};

// Settings
export const RoutePublisherSettings = {
  path: '/app/pub/:pub/publisher-settings',
  title: 'General Settings',
};

export const RouteAccountSettings = {
  path: '/app/pub/:pub/account-settings',
  title: 'Account Settings',
};

export const RoutePublisherChangeLogs = {
  path: '/app/pub/:pub/change-logs',
  title: 'Change Logs',
};

export const RouteBillingDetailList = {
  path: '/app/pub/:pub/billing-details',
  title: 'Billing Details',
};

export const RouteBillingDetailConfigurationNew = {
  path: '/app/pub/:pub/billing-detail-configuration/new',
  title: 'Billing Detail',
};

export const RouteBillingDetailConfigurationExisting = {
  path: '/app/pub/:pub/billing-detail-configuration/:billingdetailconfiguration',
  title: 'Billing Detail',
};

export const RouteBillingDetailTiersNew = {
  path: '/app/pub/:pub/billing-detail-tiers/new',
  title: 'Billing Detail',
};

export const RouteBillingDetailTiersExisting = {
  path: '/app/pub/:pub/billing-detail-tiers/:billingdetailtiers',
  title: 'Billing Detail',
};

export const RouteTeamSettings = {
  path: '/app/pub/:pub/team',
  title: 'Team',
};

export const RouteCampaignSettingsList = {
  path: '/app/pub/:pub/line-items',
  title: 'Line Items',
};

export const RouteCreativesLibraryList = {
  path: '/app/pub/:pub/creative-library',
  title: 'Creative Library',
};

export const RouteCampaignNew = {
  path: '/app/pub/:pub/orders/:order/line-items/new',
  title: 'Line Item Settings',
};

export const RouteCampaignCopy = {
  path: '/app/pub/:pub/orders/:order/line-items/copy/:campaign',
  title: 'Line Item Settings',
};

export const RouteCampaignExisting = {
  path: '/app/pub/:pub/orders/:order/line-items/line-item/:campaign',
  title: 'Line Item Settings',
};

export const RouteAudienceDataShareManager = {
  path: '/app/pub/:pub/audience-data-share-manager',
  title: 'Audience Data Share',
};

export const RouteAudienceManagerSettingsList = {
  path: '/app/pub/:pub/segments/audience',
  title: 'Audience Manager',
};

export const RouteAudienceManagerSegmentNew = {
  path: '/app/pub/:pub/segments/audience/new',
  title: 'Create new Segment',
};

export const RouteAudienceManagerCombineSegments = {
  path: '/app/pub/:pub/segments/audience/combine',
  title: 'Combine Segments',
};

export const RouteAudienceManagerDataProviderSettings = {
  path: '/app/pub/:pub/segments/audience/data-provider-settings',
  title: 'Data Provider Settings',
};

export const RouteAudienceManagerSegmentExisting = {
  path: '/app/pub/:pub/segments/audience/:audience',
  title: 'Audience Manager Settings',
};

export const RouteAudienceManagerLiverampMarketplace = {
  path: '/app/pub/:pub/liveramp/marketplace',
  title: 'LiveRamp Data Marketplace',
};

export const RouteSegmentsLiverampDistribution = {
  path: '/app/pub/:pub/segments/liveramp/distribution',
  title: 'Audience Manager Settings',
};

export const RouteContextualSegmentSettingsList = {
  path: '/app/pub/:pub/segments/contextual',
  title: 'Contextual Segments',
};

export const RouteContextualSegmentNew = {
  path: '/app/pub/:pub/segments/contextual/new',
  title: 'New Contextual Segment',
};

export const RouteContextualSegmentExisting = {
  path: '/app/pub/:pub/segments/contextual/:contextual',
  title: 'Contextual Segment Settings',
};

export const RouteNetworkDashboard = {
  path: '/app/pub/:pub/network-dashboard',
  title: 'Network Dashboard',
};

export const RouteNetworkList = {
  path: '/app/pub/:pub/network-list',
  title: 'Network List',
};

export const RouteNetworkSettingsExisting = {
  path: '/app/pub/:pub/network/:network',
  title: 'Network Settings',
};

export const RouteNetworkSettingsNew = {
  path: '/app/pub/:pub/network/new',
  title: 'Create new network',
};

export const RouteNetworkSettingsClone = {
  path: '/app/pub/:pub/networks/clone/:network',
  title: 'Network Settings',
};

export const RouteResellerManagerList = {
  path: '/app/pub/:pub/reseller',
  title: 'Reseller',
};

export const RouteResellerNew = {
  path: '/app/pub/:pub/reseller/new',
  title: 'Reseller',
};

export const RouteResellerExisting = {
  path: '/app/pub/:pub/reseller/:reseller',
  title: 'Reseller Settings',
};

export const RouteBrandSafetyList = {
  path: '/app/pub/:pub/brandsafety',
  title: 'Brand Safety',
};

export const RouteBrandSafetyNew = {
  path: '/app/pub/:pub/brandsafety/new',
  title: 'Brand Safety Rule',
};

export const RouteBrandSafetyEdit = {
  path: '/app/pub/:pub/brandsafety/:brandsafetyrule',
  title: 'Brand Safety Rule',
};

export const RouteBrandSafetyTrackerNew = {
  path: '/app/pub/:pub/brandsafetytracker/new',
  title: 'Brand Safety Tracker',
};

export const RouteBrandSafetyTrackerEdit = {
  path: '/app/pub/:pub/brandsafetytracker/:brandsafetytracker',
  title: 'Brand Safety Tracker',
};

export const RouteDealList = {
  path: '/app/pub/:pub/deals',
  title: 'Deals',
};

export const RouteDealTPAccountList = {
  path: '/app/pub/:pub/deals/tp_accounts',
  title: 'Deal Third Party Accounts',
};

export const RouteDealNew = {
  path: '/app/pub/:pub/deals/new',
  title: 'Deal Create',
};

export const RouteDealCreate = {
  path: '/app/pub/:pub/deals/create',
  title: 'Deal Create',
};

export const RouteDealClone = {
  path: '/app/pub/:pub/deals/clone/:deal',
  title: 'Deal Create',
};

export const RouteDealEdit = {
  path: '/app/pub/:pub/deals/:deal',
  title: 'Deal Settings',
};

export const RouteIPTraceList = {
  path: '/app/pub/:pub/iptraces',
  title: 'IP Traces',
};

export const RouteIPTraceNew = {
  path: '/app/pub/:pub/iptrace/new',
  title: 'IP Trace',
};

export const RouteFreewheelSiteList = {
  path: '/app/pub/:pub/freewheelsites',
  title: 'Freewheel Sites *',
};

export const RouteFreewheelSiteNew = {
  path: '/app/pub/:pub/freewheelsites/create',
  title: 'Create Freewheel Site',
};

export const RouteFreewheelSiteEdit = {
  path: '/app/pub/:pub/freewheelsites/:freewheelsite',
  title: 'Edit Freewheel Site',
};

export const RouteOrderList = {
  path: '/app/pub/:pub/orders',
  title: 'Orders',
};

export const RouteOrderSettingsNew = {
  path: '/app/pub/:pub/orders/new',
  title: 'Order Settings',
};

export const RouteOrderSettingsExisting = {
  path: '/app/pub/:pub/orders/:order',
  title: 'Order Settings',
};

export const RouteOrderSettingsClone = {
  path: '/app/pub/:pub/orders/:order/clone',
  title: 'Clone Order',
};

export const RouteConfigurations = {
  path: '/app/pub/:pub/configurations',
  title: 'Configurations',
};

// Monitors
export const RouteMonitorList = {
  path: '/app/pub/:pub/monitor',
  title: 'Monitors',
};

export const RouteMonitorNew = {
  path: '/app/pub/:pub/monitor/new',
  title: 'New Monitor',
};

export const RouteMonitorBulkUpload = {
  path: '/app/pub/:pub/monitor/upload',
  title: 'Bulk Upload Monitors',
};

export const RouteMonitorEdit = {
  path: '/app/pub/:pub/monitor/:monitorid',
  title: 'Edit Monitor',
};

export const RouteMonitorBulkUpdate = {
  path: '/app/pub/:pub/bulk-update-monitors',
  title: 'Bulk Update Monitors',
};

export const RouteForecasting = {
  path: '/app/pub/:pub/forecasting',
  title: 'Forecasting',
};

export const RouteInventoryForecast = {
  path: '/app/pub/:pub/inventory-forecast',
  title: 'Inventory Forecasting',
};

export const RouteInventoryRouteNew = {
  path: '/app/pub/:pub/inventory-routes/new',
  title: 'New Inventory Route',
};

export const RouteInventoryRouteEdit = {
  path: '/app/pub/:pub/inventory-routes/:inventoryrouteid',
  title: 'Edit Inventory Route',
};

export const RouteInventoryRouteList = {
  path: '/app/pub/:pub/inventory-routes',
  title: 'Inventory Routes',
};

export const RouteInventoryRules = {
  path: '/app/pub/:pub/inventory-rules',
  title: 'Inventory Rules',
};

export const RouteMeasurementDashboard = {
  path: '/app/pub/:pub/measurement-dashboard',
  title: 'Measurement Dashboard',
};

export const RouteMeasurementDrill = {
  path: '/app/pub/:pub/measurement-drill',
  title: 'Measurement Drill',
};

// IAS WHITELABEL
export const RouteIASDashboard = {
  path: '/app/pub/:pub/iasdashboard',
  title: 'Dashboard',
};

export const RouteIASHelp = {
  path: 'http://www.google.com', // placeholder URL
  title: 'Help',
};

export const RouteIASGlossary = {
  path: '/app/pub/:pub/reference/iasglossary',
  title: 'Glossary',
};

export const RouteReportsDashboard = {
  path: '/app/pub/:pub/iasreporting/reports-dashboard',
  title: 'Reports Dashboard',
};

export const RouteReportBuilderList = {
  path: '/app/pub/:pub/iasreporting/report-builder',
  title: 'Reports',
};

export const RouteReportBuilderNew = {
  path: '/app/pub/:pub/iasreporting/report-builder/new',
  title: 'New Report',
};

export const RouteReportBuilderExisting = {
  path: '/app/pub/:pub/iasreporting/report-builder/report/:report',
  title: 'Edit Report',
};

// TODO:
// export const RouteIASContextControl = {
//   path: '/app/pub/:pub/reference/context-control',
//   title: 'Context Control',
// };

export const RouteBrandsDashboard = {
  path: '/app/pub/:pub/brands-dashboard',
  title: 'Brands Dashboard',
};

export const RouteSandbox = {
  path: '/app/pub/:pub/sandbox',
  title: 'Sandbox',
};

export const RouteMobileHome = {
  path: '/app/pub/:pub/mobile/home',
  title: 'Mobile Dashboard',
};

export const RoutePlatformConnects = {
  path: '/app/pub/:pub/platform-connect',
  title: 'Platform Connect *',
};

export const RoutePlatformConnectOfferNew = {
  path: '/app/pub/:pub/platform-connect/offer/new',
  title: 'Draft New Offer',
};

export const RouteDashboards = {
  path: '/app/pub/:pub/dashboards',
  title: 'Dashboards',
};

// Targeting Presets
export const RouteTargetingList = {
  path: '/app/pub/:pub/targeting',
  title: 'Targeting Presets',
};

export const RouteTargetingPresetNew = {
  path: '/app/pub/:pub/targeting/preset/new',
  title: 'Targeting Preset',
};

export const RouteTargetingPresetExisting = {
  path: '/app/pub/:pub/targeting/preset/:targetingpresetid',
  title: 'Targeting Preset',
};

export const RouteTargetingPresetClone = {
  path: '/app/pub/:pub/targeting/clone-preset/:presetid',
  title: 'Review Cloned Preset',
};

const routes = [
  RouteAccountSettings,
  RouteBidderReportsList,
  RouteBidderBulkUpload,
  RouteBidderSettingsList,
  RouteBidderSettingsNew,
  RouteBidderSettingsExisting,
  RouteBidderSettingsClone,
  RouteBidderBulkUpdate,
  RouteBillingDetailConfigurationExisting,
  RouteBillingDetailConfigurationNew,
  RouteBillingDetailList,
  RouteBillingDetailTiersExisting,
  RouteBillingDetailTiersNew,
  RouteInventoryRouteList,
  RouteChannelsView,
  RouteChannelBulkUpdate,
  RouteChannelNew,
  RouteChannelExisting,
  RouteChannelGroupBulkUpdate,
  RouteIABCategoryManager,
  RoutePublisherChangeLogs,
  RoutePublisherSettings,
  RouteTeamSettings,
  RouteSSPReportList,
  RouteSSPReportExisting,
  RouteSSPReportNew,
  RouteCampaignCopy,
  RouteCampaignNew,
  RouteCampaignSettingsList,
  RouteCreativesLibraryList,
  RouteCampaignExisting,
  RouteAudienceDataShareManager,
  RouteAudienceManagerSettingsList,
  RouteAudienceManagerSegmentNew,
  RouteAudienceManagerCombineSegments,
  RouteAudienceManagerSegmentExisting,
  RouteAudienceManagerDataProviderSettings,
  RouteContextualSegmentSettingsList,
  RouteContextualSegmentNew,
  RouteContextualSegmentExisting,
  RouteNetworkDashboard,
  RouteNetworkList,
  RouteNetworkSettingsExisting,
  RouteNetworkSettingsClone,
  RouteNetworkSettingsNew,
  RouteResellerManagerList,
  RouteResellerExisting,
  RouteResellerNew,
  RouteBrandSafetyList,
  RouteBrandSafetyNew,
  RouteBrandSafetyEdit,
  RouteBrandSafetyTrackerNew,
  RouteBrandSafetyTrackerEdit,
  RouteDealList,
  RouteDealNew,
  RouteDealCreate,
  RouteDealEdit,
  RouteDealClone,
  RouteDealTPAccountList,
  RouteIPTraceList,
  RouteIPTraceNew,
  RouteFreewheelSiteList,
  RouteFreewheelSiteNew,
  RouteFreewheelSiteEdit,
  RouteOrderList,
  RouteOrderSettingsNew,
  RouteOrderSettingsExisting,
  RouteOrderSettingsClone,
  RouteConfigurations,
  RouteMonitorList,
  RouteMonitorNew,
  RouteMonitorEdit,
  RouteMonitorBulkUpdate,
  RouteMonitorBulkUpload,
  RouteInventoryForecast,
  RouteInventoryRouteNew,
  RouteInventoryRouteEdit,
  RouteInventoryRules,
  RouteMeasurementDashboard,
  RouteMeasurementDrill,
  RouteIASDashboard,
  RouteBrandsDashboard,
  RouteIASGlossary,
  RouteReportsDashboard,
  RouteReportBuilderList,
  RouteReportBuilderNew,
  RouteReportBuilderExisting,
  RouteSandbox,
  RouteMobileHome,
  RoutePlatformConnects,
  RoutePlatformConnectOfferNew,
  RouteDashboards,
  RouteTargetingList,
  RouteTargetingPresetNew,
  RouteTargetingPresetExisting,
  RouteReportsList,
  RouteTargetingPresetClone,
];

const reUser = /\/user\/(\d+)\/([^\/]+)/i;
const rePub = /\/pub\/(\d+)\/([^\/]+)/i;
const reChannel = /\/channel\/(\d+)\/?([^\/]+)?/i;
const reAdunit = /\/unit\/(\d+)\/([^\/]+)/i;
const reReport = /\/reports?\/(\d+)/i;
const reBidder = /\/bidder\/(\d+)/i;
const reReseller = /\/reseller\/(\d+)/i;
const reCampaign = /\/(campaign|line-item|line-items\/copy)\/(\d+)/i;
const reAudience = /\/audience\/(\d+)/i;
const reNetwork = /\/(network|networks\/clone)\/(\d+)/i;
const reBrandSafetyRule = /\/brandsafety\/(\d+)/i;
const reBrandSafetyTracker = /\/brandsafetytracker\/(\d+)/i;
const reDeal = /\/(deals)\/(\d+)/i;
const reIPTrace = /\/(iptraces)\/(\d+)/i;
const reFreewheelSite = /\/(freewheelsites|freewheelsite)\/(\d+)/i;
const reOrder = /\/(orders)\/(\d+)&?.*/i;
const reMonitorID = /\/(monitor)\/(\d+)/i;
const reInventoryRoute = /\/(inventory-routes)\/(\d+)/i;
const reContextual = /\/(contextual)\/(\d+)/i;
const reBillingDetailConfiguration = /\/(billing-detail-configuration)\/(\d+)/i;
const reBillingDetailTiers = /\/(billing-detail-tiers)\/(\d+)/i;
const reIASDashboard = /\/(ias-dashboard)\/(\d+)/i;
const reBrandsDashboard = /\/(brands-dashboard)\/(\d+)/i;
const reIASGlossary = /\/(ias-glossary)\/(\d+)/i;
const reReportsDashboard = /\/(reports-dashboard)\/(\d+)/i;
const reReportBuilder = /\/(report-builder)\/(\d+)/i;
const reSandbox = /\/(sandbox)\/(\d+)/i;
const reBulkUpdateChannelGroups = /\/(bulk-update-channel-groups)\/(\d+)/i;
const reTargetingPreset = /\/preset\/(\d+)/i;
const reTargetingPresetClone = /\/clone-preset\/(\d+)/i;
const rePlatformConnect = /\/(platform-connect)\/(\d+)/i;
const reInventoryRules = /\/(inventory-rules)\/(\d+)/i;

export interface ILocation {
  publisher: string;
  publisherPath: string;
  channel: string;
  channelPath: string;
  adunit: string;
  adunitPath: string;
  report: string;
  bidder: string;
  campaign: string;
  audience: string;
  network: string;
  user: string;
  userPath: string;
  reseller: string;
  brandSafety: string;
  brandSafetyTracker: string;
  freewheelsite: string;
  deal: string;
  order: string;
  iptrace: string;
  cloneId: string;
  orderPath: string;
  campaignPath: string;
  monitorid: string;
  inventoryrouteid: string;
  contextual: string;
  billingdetailconfiguration: string;
  billingdetailtiers: string;
  iasdashboard: string;
  brandsdashboard: string;
  iasglossary: string;
  reportsdashboard: string;
  reportbuilder: string;
  sandbox: string;
  bulkupdatechannelgroups: string;
  mobilehome: string;
  platformConnect: string;
  dashboards: string;
  targetingpresetid: string;
  presetid: string;
  inventoryrules: string;
}

function str(ma: RegExpExecArray | null, idx: number): string {
  if (ma) {
    return ma[idx];
  }
  return '';
}

// '/pub/33/channel/234/bidder-settings/settings/unit/123'
export function parseLocation(pathname: string, search: string = ''): Partial<ILocation> {
  const ma1 = rePub.exec(pathname);
  const ma2 = reChannel.exec(pathname);
  const ma3 = reAdunit.exec(pathname);
  const ma4 = reUser.exec(pathname);
  const ma5 = reReport.exec(pathname);
  const ma6 = reBidder.exec(pathname);
  const ma7 = reCampaign.exec(pathname);
  const ma8 = reAudience.exec(pathname);
  const ma9 = reNetwork.exec(pathname);
  const ma10 = reReseller.exec(pathname);
  const ma11 = reBrandSafetyRule.exec(pathname);
  const ma12 = reBrandSafetyTracker.exec(pathname);
  const ma13 = reDeal.exec(pathname);
  const ma14 = reIPTrace.exec(pathname);
  const ma15 = reFreewheelSite.exec(pathname);
  const ma16 = reOrder.exec(pathname);
  const ma17 = reMonitorID.exec(pathname);
  const ma18 = reInventoryRoute.exec(pathname);
  const ma19 = reContextual.exec(pathname);
  const ma20 = reBillingDetailConfiguration.exec(pathname);
  const ma21 = reBillingDetailTiers.exec(pathname);
  const ma22 = reIASDashboard.exec(pathname);
  const ma23 = reBrandsDashboard.exec(pathname);
  const ma24 = reIASGlossary.exec(pathname);
  const ma25 = reSandbox.exec(pathname);
  const ma26 = reBulkUpdateChannelGroups.exec(pathname);
  const ma27 = reReportsDashboard.exec(pathname);
  const ma28 = reReportBuilder.exec(pathname);
  const ma29 = reTargetingPreset.exec(pathname);
  const ma30 = rePlatformConnect.exec(pathname);
  const ma31 = reTargetingPresetClone.exec(pathname);
  const ma32 = reInventoryRules.exec(pathname);

  const query = parseSearch(search);
  return {
    publisher: str(ma1, 1),
    publisherPath: str(ma1, 2),
    channel: str(ma2, 1),
    channelPath: str(ma2, 2),
    adunit: str(ma3, 1),
    adunitPath: str(ma3, 2),
    user: str(ma4, 1),
    userPath: str(ma4, 2),
    report: str(ma5, 1),
    bidder: str(ma6, 1),
    campaign: str(ma7, 2),
    campaignPath: str(ma7, 0),
    audience: str(ma8, 1),
    network: str(ma9, 2),
    reseller: str(ma10, 1),
    brandSafety: str(ma11, 1),
    brandSafetyTracker: str(ma12, 1),
    deal: str(ma13, 2),
    iptrace: str(ma14, 2),
    freewheelsite: str(ma15, 2),
    order: str(ma16, 2),
    orderPath: str(ma16, 0),
    cloneId: query.cloneId,
    monitorid: str(ma17, 2),
    inventoryrouteid: str(ma18, 2),
    contextual: str(ma19, 2),
    billingdetailconfiguration: str(ma20, 2),
    billingdetailtiers: str(ma21, 2),
    iasdashboard: str(ma22, 1),
    brandsdashboard: str(ma23, 1),
    iasglossary: str(ma24, 1),
    sandbox: str(ma25, 1),
    bulkupdatechannelgroups: str(ma26, 1),
    reportsdashboard: str(ma27, 1),
    reportbuilder: str(ma28, 1),
    targetingpresetid: str(ma29, 1),
    platformConnect: str(ma30, 1),
    presetid: str(ma31, 1),
    inventoryrules: str(ma32, 1),
  };
}

export interface IInventoryRouteParams {
  publisherID?: any;
  p?: any;
  channel?: any;
  ch?: any;
  adunitID?: any;
  a?: any;
  userID?: any;
  u?: any;
  reportID?: any;
  r?: any;
  bidderID?: any;
  b?: any;
  campaignID?: any;
  c?: any;
  audienceID?: any;
  seg?: any;
  networkID?: any;
  net?: any;
  resellerID?: any;
  re?: any;
  brandSafetyRuleID?: any;
  brandSafetyTrackerID?: any;
  freewheelsite?: any;
  dealID?: string | number;
  order?: any;
  ipTraceID?: string | number;
  clone?: any;
  orderPath?: string;
  campaignPath?: string;
  monitorid?: any;
  inventoryrouteid?: any;
  contextual?: any;
  billingdetailconfiguration?: any;
  billingdetailtiers?: any;
  m?: any;
  iasdashboard?: any;
  brandsdashboard?: any;
  iasglossary?: any;
  reportsdashboard?: any;
  reportbuilder?: any;
  sandbox?: any;
  bulkupdatechannelgroups?: any;
  mobilehome?: any;
  dashboards?: any;
  targetingpresetid?: any;
  presetid?: any;
}

export interface IInventoryRouteConfig {
  pub: string;
  channel: string;
  unit: string;
  user: string;
  report: string;
  bidder: string;
  campaign: string;
  audience: string;
  network: string;
  reseller: string;
  brandsafetyrule: string;
  brandsafetytracker: string;
  freewheelsite: string;
  deal: string;
  order: string;
  iptrace: string;
  clone: string;
  orderPath: string;
  campaignPath: string;
  monitorid: string;
  inventoryrouteid: string;
  contextual: string;
  billingdetailconfiguration: string;
  billingdetailtiers: string;
  iasdashboard: string;
  brandsdashboard: string;
  iasglossary: string;
  reportsdashboard: string;
  reportbuilder: string;
  sandbox: string;
  bulkupdatechannelgroups: string;
  mobilehome: string;
  dashboards: string;
  targetingpresetid: string;
  presetid: string;
}

function getVal(
  rp: IInventoryRouteParams & { [key: string]: string | undefined },
  keys: string[],
): string {
  for (let i = 0; i < keys.length; i += 1) {
    if (typeof rp[keys[i]] === 'string') {
      return '' + rp[keys[i]];
    }
  }
  return '';
}

const NumericRouteParams = [
  'b',
  'dealID',
  'ipTraceID',
  'ch',
  'channel',
  'channelID',
  'm',
  'monitorid',
  'targetingpresetid',
  'presetid',
];
function mergeRouteParams(_rps: IInventoryRouteParams[]): IInventoryRouteConfig {
  const rps = Object.assign({}, ..._rps);

  NumericRouteParams.forEach((paramKey) => {
    if (typeof rps[paramKey] === 'number') {
      rps[paramKey] = rps[paramKey].toString();
    }
  });

  return {
    pub: getVal(rps, ['p', 'pub', 'publisherID']),
    channel: getVal(rps, ['ch', 'channel', 'channelID']),
    unit: getVal(rps, ['a', 'unit', 'adunitID']),
    user: getVal(rps, ['u', 'user', 'userID']),
    report: getVal(rps, ['r', 'report', 'reportID']),
    bidder: getVal(rps, ['b', 'bidder', 'bidderID']),
    campaign: getVal(rps, ['c', 'campaign', 'campaignID']),
    audience: getVal(rps, ['aud', 'audience', 'audienceID']),
    network: getVal(rps, ['net', 'network', 'networkID']),
    reseller: getVal(rps, ['re', 'reseller', 'resellerID']),
    brandsafetyrule: getVal(rps, ['brandSafetyRuleID']),
    brandsafetytracker: getVal(rps, ['brandSafetyTrackerID']),
    freewheelsite: getVal(rps, ['freewheelsite']),
    deal: getVal(rps, ['dealID']),
    order: getVal(rps, ['order']),
    iptrace: getVal(rps, ['ipTraceID']),
    clone: getVal(rps, ['clone']),
    orderPath: getVal(rps, ['orderPath']),
    campaignPath: getVal(rps, ['campaignPath']),
    monitorid: getVal(rps, ['m', 'monitorid']),
    inventoryrouteid: getVal(rps, ['m', 'inventoryrouteid']),
    contextual: getVal(rps, ['m', 'contextual']),
    billingdetailconfiguration: getVal(rps, ['billingdetailconfiguration']),
    billingdetailtiers: getVal(rps, ['billingdetailtiers']),
    iasdashboard: getVal(rps, ['iasdashboard']),
    brandsdashboard: getVal(rps, ['brandsdashboard']),
    iasglossary: getVal(rps, ['iasglossary']),
    reportsdashboard: getVal(rps, ['reportsdashboard']),
    reportbuilder: getVal(rps, ['reportbuilder']),
    sandbox: getVal(rps, ['sandbox']),
    bulkupdatechannelgroups: getVal(rps, ['bulkupdatechannelgroups']),
    mobilehome: getVal(rps, ['mobilehome']),
    dashboards: getVal(rps, ['dashboards']),
    targetingpresetid: getVal(rps, ['targetingpresetid']),
    presetid: getVal(rps, ['presetid']),
  };
}

export function getRoutePath(route: IInventoryRoute, ...rps: IInventoryRouteParams[]) {
  const rp = mergeRouteParams(rps);
  return route.path.replace(/\/:([^\/]+)/gi, (_m: string, key: string) => {
    if ((rp as any)[key]) {
      return '/' + (rp as any)[key];
    }
    return '';
  });
}

export function extractRouteParams({
  session,
  user,
}: {
  session?: ISessionState;
  user?: IUserState;
}): IInventoryRouteParams {
  return {
    p: session && session.publisher ? session.publisher.ID : '',
    ch: session && session.site ? session.site.ID : '',
    a: session && session.adunit ? session.adunit.ID : '',
    u: user && user.user ? user.user.ID : '',
  };
}

export function getRoute(pathname: string): IInventoryRoute {
  const loc = parseLocation(pathname);
  const ignoreParams = pathname.split('&')[0];
  for (let i = 0; i < routes.length; i += 1) {
    if (
      ignoreParams ===
      getRoutePath(routes[i], {
        p: loc.publisher,
        ch: loc.channel,
        a: loc.adunit,
        u: loc.user,
        b: loc.bidder,
        r: loc.report,
        c: loc.campaign,
        audienceID: loc.audience,
        net: loc.network,
        re: loc.reseller,
        brandSafetyRuleID: loc.brandSafety,
        brandSafetyTrackerID: loc.brandSafetyTracker,
        freewheelsite: loc.freewheelsite,
        dealID: loc.deal,
        order: loc.order,
        ipTraceID: loc.iptrace,
        clone: loc.cloneId,
        orderPath: loc.orderPath,
        campaignPath: loc.campaignPath,
        monitorid: loc.monitorid,
        inventoryrouteid: loc.inventoryrouteid,
        contextual: loc.contextual,
        billingdetailconfiguration: loc.billingdetailconfiguration,
        billingdetailtiers: loc.billingdetailtiers,
        iasdashboard: loc.iasdashboard,
        brandsdashboard: loc.brandsdashboard,
        iasglossary: loc.iasglossary,
        reportsdashboard: loc.reportsdashboard,
        reportbuilder: loc.reportbuilder,
        sandbox: loc.sandbox,
        bulkupdatechannelgroups: loc.bulkupdatechannelgroups,
        mobilehome: loc.mobilehome,
        dashboards: loc.dashboards,
        targetingpresetid: loc.targetingpresetid,
        presetid: loc.presetid,
      })
    ) {
      return routes[i];
    }
  }
  throw new Error('route not found');
}

export type ItemRouteType = 'Bidders' | 'Campaigns';

export interface IItemRouteID {
  value: string | number;
  parentID: number;
}

export const getItemRoute = (
  type: ItemRouteType,
  itemRouteID: IItemRouteID,
  session: ISessionState,
  user: IUserState,
) => {
  const itemIDString = (itemRouteID?.value || 0).toString();
  switch (type) {
    case 'Bidders':
      return getRoutePath(RouteBidderSettingsExisting, extractRouteParams({ session, user }), {
        b: itemIDString,
      });
    case 'Campaigns':
      return getRoutePath(RouteCampaignExisting, extractRouteParams({ session, user }), {
        c: (itemIDString || 0).toString(),
        order: (itemRouteID.parentID || 0).toString(),
      });
    default:
      return '#';
  }
};

// -------------------- NAVIGATE FUNCTIONS --------------------

export function navigate(route: IInventoryRoute | string, ...rps: IInventoryRouteParams[]) {
  setTimeout(() => {
    if (typeof route === 'string') {
      window.location.href = '/#' + route;
      return;
    }
    window.location.href = '/#' + getRoutePath(route as IInventoryRoute, ...rps);
  }, 1);
}

export function navigateToBulkUpdateRoute(
  route: IInventoryRoute | string,
  ids: Array<string | number>,
  ...rps: IInventoryRouteParams[]
) {
  setTimeout(() => {
    window.location.href =
      '/#' + getRoutePath(route as IInventoryRoute, ...rps) + '?bulk_edit_ids=' + ids.join(',');
  }, 1000);
}

export function navigateToRouteWithQueryParams(
  route: IInventoryRoute | string,
  queryParams: { [key: string]: any },
  ...rps: IInventoryRouteParams[]
) {
  setTimeout(() => {
    window.location.href =
      '/#' + getRoutePath(route as IInventoryRoute, ...rps) + '?' + encodeQuery(queryParams);
  }, 1000);
}

export function reload(route: IInventoryRoute | string, ...rps: IInventoryRouteParams[]) {
  setTimeout(() => {
    let loc = window.location.href;
    if (loc.indexOf('#') > -1) {
      loc = loc.substring(0, loc.indexOf('#'));
    }
    if (typeof route === 'string') {
      window.location.href = loc + '#' + route;
    } else {
      window.location.href = loc + '#' + getRoutePath(route as IInventoryRoute, ...rps);
    }
    window.location.reload();
  }, 1);
}

export function navigateError() {
  setTimeout(() => {
    window.location.href = '/#/error';
  }, 1);
}

export function genReportURL(
  params: { [key: string]: any } | string,
  eventUUID?: string,
  snowflakeDebug?: boolean,
  previewBeta?: boolean,
) {
  return (
    (previewBeta
      ? // @ts-ignore
        `/#/app/pub/${params.publisher_id}/reports/${params.report_id}/preview?`
      : '/#/app/report/view?') +
    encodeParams(params) +
    (eventUUID ? `&event_uuid=${eventUUID}` : '') +
    (snowflakeDebug ? '&snowflake_debug=true' : '')
  );
}

export function createDownloadReportURL(
  params: { [key: string]: any } | string,
  isIASReport: boolean,
) {
  if (isIASReport) {
    return `${getApiDomain()}/v1/settings/download_ias_report?access_token=${
      getToken().access_token
    }&${encodeParams(params)}`;
  }
  return `${getApiDomain()}/v1/analytics/discovery/download_report?access_token=${
    getToken().access_token
  }&${encodeParams(params)}`;
}

export function genDownloadCampaignsCSVURL(
  publisherID: string,
  isNewCSV: boolean,
  orderID: string,
  publisherName: string,
) {
  const template_id = isNewCSV ? 'campaign_new' : 'campaign_updates';
  if (isNewCSV) {
    return `${getApiDomain()}/v1/settings/download_bulkupload_csv?access_token=${
      getToken().access_token
    }&publisher_id=${publisherID}&template_id=${template_id}&name=${publisherName}_bulk_upload_${formatDateSmall(
      moment(),
    )}&new_csv=true`;
  }
  return `${getApiDomain()}/v1/settings/download_bulkupload_csv?access_token=${
    getToken().access_token
  }&publisher_id=${publisherID}&template_id=${template_id}&name=${publisherName}_bulk_upload_${formatDateSmall(
    moment(),
  )}&order_id=${orderID}`;
}

export function genDownloadBiddersCSVURL(publisherID: string, template_id: string) {
  return `${getApiDomain()}/v1/settings/download_bulkupload_csv?access_token=${
    getToken().access_token
  }&publisher_id=${publisherID}&template_id=${template_id}_new&name=${template_id}_bulk_upload_${formatDateSmall(
    moment(),
  )}`;
}

export function genDownloadMonitorCSVURL(publisherID: string) {
  return `${getApiDomain()}/v1/settings/download_monitor_csv?access_token=${
    getToken().access_token
  }&publisher_id=${publisherID}`;
}

export function genDownloadVastCSVURL(publisherID: string, isNewCSV: boolean) {
  if (isNewCSV) {
    return `${getApiDomain()}/v1/settings/download_vast_csv?access_token=${
      getToken().access_token
    }&publisher_id=${publisherID}&new_csv=true`;
  }
  return `${getApiDomain()}/v1/settings/download_vast_csv?access_token=${
    getToken().access_token
  }&publisher_id=${publisherID}`;
}

export function genDownloadAPSCSVURL(publisherID: string) {
  return `${getApiDomain()}/v1/settings/download_aps_csv?access_token=${
    getToken().access_token
  }&publisher_id=${publisherID}`;
}

export function genDownloadDOOHCSVURL(publisherID: string) {
  return `${getApiDomain()}/v1/settings/download_dooh_csv?access_token=${
    getToken().access_token
  }&publisher_id=${publisherID}`;
}

export function genDownloadCollectionDataCSVURL(publisherID: string, collectionID: number) {
  return `${getApiDomain()}/v1/settings/download_collection_data_csv?access_token=${
    getToken().access_token
  }&publisher_id=${publisherID}&collection_id=${collectionID}`;
}

export function genDownloadEPGChannelCSVURL(publisherID: string) {
  return `${getApiDomain()}/v1/settings/download_epg_channel_csv?access_token=${
    getToken().access_token
  }&publisher_id=${publisherID}`;
}

export function genDownloadGlobalAppBundleBlockListURL() {
  return `${getApiDomain()}/v1/settings/download_gapbl_csv?access_token=${getToken().access_token}`;
}

export function logout() {
  setTimeout(() => {
    setToken('');
    window.location.href = '/#/signin';
    window.location.reload();
    sessionStorage.setItem('forceDesktop', 'false');
  }, 1);
}

export const V2_ROUTES = [
  RouteCampaignExisting.path,
  RouteCampaignNew.path,
  RouteCampaignCopy.path,
  RouteBidderSettingsExisting.path,
  RouteBidderBulkUpdate.path,
  RouteBidderSettingsNew.path,
  RouteBidderSettingsClone.path,
  RouteNetworkSettingsExisting.path,
  RouteNetworkSettingsClone.path,
  RouteNetworkSettingsNew.path,
  RouteBrandSafetyNew.path,
  RouteBrandSafetyEdit.path,
  RouteBrandSafetyTrackerNew.path,
  RouteBrandSafetyTrackerEdit.path,
  RouteDealNew.path,
  RouteDealTPAccountList.path,
  RouteDealCreate.path,
  RouteDealClone.path,
  RouteDealEdit.path,
  RouteIPTraceList.path,
  RouteIPTraceNew.path,
  RouteFreewheelSiteNew.path,
  RouteFreewheelSiteEdit.path,
  RouteChannelBulkUpdate.path,
  RouteChannelNew.path,
  RouteChannelExisting.path,
  RouteChannelsView.path,
  RouteOrderSettingsNew.path,
  RouteOrderSettingsExisting.path,
  RouteOrderSettingsClone.path,
  RouteConfigurations.path,
  RouteMonitorBulkUpdate.path,
  RouteMonitorEdit.path,
  RouteMonitorNew.path,
  RouteForecasting.path,
  RouteInventoryForecast.path,
  RouteInventoryRouteNew.path,
  RouteInventoryRouteEdit.path,
  RouteContextualSegmentNew.path,
  RouteContextualSegmentExisting.path,
  RouteTargetingList.path,
  RouteTargetingPresetNew.path,
  RouteTargetingPresetExisting.path,
  RouteTargetingPresetClone.path,
];

export function doesRouteMatch(path: string, routePath: string): boolean {
  return (
    matchPath(path, {
      path: routePath,
    }) || { isExact: false }
  ).isExact;
}

export function getRouteTitle(currentPath: string): string {
  for (const path of routes) {
    if (doesRouteMatch(currentPath, path.path)) {
      return path.title;
    }
  }
  return '';
}

export function isPathV2(currentPath: string): boolean {
  for (const path of V2_ROUTES) {
    if (doesRouteMatch(currentPath, path)) {
      return true;
    }
  }
  return false;
}

// -------------------- QUERY PARAM FUNCTIONS --------------------

// Returns string based on query params
export const setStringFromParam = (
  url: string,
  param: string,
  defaultValue: string = '',
): string => {
  const queryParams = new URLSearchParams(url);
  const queryParam = queryParams.get(param);
  return queryParam ? queryParam : defaultValue;
};

// pass in this.props.location.search and the first query param id (like ?channel_group_id=155)
export const getIDFromQueryParam = (search: string, targetID: string): number => {
  let id = '';
  if (search.indexOf(`?${targetID}=`) > -1) {
    id = search.split('=')[1];
  }
  if (id === '') {
    return 0;
  } else {
    return parseInt(id, 10);
  }
};

export const extractPublisherIDFromRoute = (path: string) => {
  try {
    const regexp = new RegExp(/^#?\/app\/pub\/(\d+)\/.*$/g, 'g');
    const pid = regexp.exec(path);
    if (!pid || pid.length < 2) {
      return '';
    }
    return parseInt(pid[1], 10);
  } catch (e) {
    return '';
  }
};
